import { OpPage } from 'components/customAntd/OpPage/OpPage';
import React from 'react';
import { Row, Col, Empty } from 'antd';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
    const { t } = useTranslation();

    return (
        <OpPage>
            <Row justify="center" align="middle" style={{ height: '100%' }}>
                <Col>
                    <Empty description={
                        <div>
                            <h1>{t('notFound.title')}</h1>
                            <p>{t('notFound.message')}</p>
                        </div>
                    } />
                </Col>
            </Row>
        </OpPage>
    );
};

export default NotFound;
